import { takeEvery, put, call } from "redux-saga/effects";
import {
  changePasswordSuccess,
  editProfileSuccess,
  getProfileSuccess,
  resetProfileFlag,
  editProfileError,
  changePasswordError,
  updateProfileAvatarSuccess,
  updateProfileAvatarError,
} from "./actions";
import {
  getUserProfile,
  updateUserProfile,
  changeUserPassword,
  updateProfileAvatarAPI,
} from "../../../helpers/backend.helper";

import {
  EDIT_PROFILE,
  GET_PROFILE,
  CHANGE_PASSWORD,
  UPDATE_PROFILE_AVATAR,
} from "./actionTypes";
import { logoutUser } from "../login/actions";

export function* getProfile() {
  try {
    const response = yield call(getUserProfile);
    yield put(getProfileSuccess(response?.data));
  } catch (error) {
    yield put(logoutUser(error));
  }
}

function* editProfile({ payload: { user } }) {
  try {
    const response = yield call(updateUserProfile, {
      firstName: user.firstName,
      lastName: user.lastName,
      mobile: user.mobile,
    });
    yield put(editProfileSuccess(response?.data));
    yield put(resetProfileFlag());
  } catch (error) {
    yield put(editProfileError(error));
  }
}

export function* changePassword({ payload: { changes } }) {
  try {
    yield call(changeUserPassword, {
      oldPassword: changes.oldPassword,
      password: changes.password,
      confirmPassword: changes.confirmPassword,
    });
    yield put(changePasswordSuccess("Password changed successfully"));
  } catch (error) {
    yield put(changePasswordError(error));
  }
}

export function* updateProfileAvatar({ payload: { avatar } }) {
  try {
    const response = yield call(updateProfileAvatarAPI, avatar);
    yield put(updateProfileAvatarSuccess(response?.data));
  } catch (error) {
    yield put(updateProfileAvatarError(error));
  }
}

function* ProfileSaga() {
  yield takeEvery(EDIT_PROFILE, editProfile);
  yield takeEvery(GET_PROFILE, getProfile);
  yield takeEvery(CHANGE_PASSWORD, changePassword);
  yield takeEvery(UPDATE_PROFILE_AVATAR, updateProfileAvatar);
}

export default ProfileSaga;
